import { cn } from '@/src/core/utils/cn'
import { forwardRef } from 'react'

export interface FormFieldProperties {
	label?: string
	error?: string
	hint?: string
	required?: boolean
	className?: string
	children: React.ReactNode
	htmlFor?: string
}

export const FormField = forwardRef<HTMLDivElement, FormFieldProperties>(
	({ label, error, hint, required, className, children, htmlFor }, reference) => {
		return (
			<div ref={reference} className={cn('space-y-2', className)}>
				{label ? (
					<label htmlFor={htmlFor} className="block text-sm font-medium text-white">
						{label}
						{required ? <span className="ml-1 text-red-400">*</span> : undefined}
					</label>
				) : undefined}

				<div>{children}</div>

				{error || hint ? (
					<div className="space-y-1">
						{error ? (
							<p className="text-sm text-red-400" role="alert" aria-live="polite">
								{error}
							</p>
						) : undefined}
						{hint && !error ? <p className="text-sm text-white/60">{hint}</p> : undefined}
					</div>
				) : undefined}
			</div>
		)
	}
)

FormField.displayName = 'FormField'
